import { SVGAttributes } from 'react';
import styled from 'styled-components';

export type IconSize = 'tiny' | 'micro' | 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge';

export interface IconProps extends SVGAttributes<SVGSVGElement> {
    size?: IconSize;
    color?: string;
    accent?: string;
    className?: string;
}

export interface WrapperProps {
    size?: string;
    color?: string;
    className?: string;
    borderWidth?: string;
    borderColor?: string;
    image?: string | null;
}

export interface StyledSvgProps {
    size?: IconSize;
}

export const StyledSvg = styled.svg<StyledSvgProps>`
    ${(props) =>
        props.size === 'tiny' &&
        `
        width: 10px;
        height: 10px;
    `};
    ${(props) =>
        props.size === 'micro' &&
        `
        width: 14px;
        height: 14px;
    `};
    ${(props) =>
        props.size === 'xSmall' &&
        `
            width: 18px;
            height: 18px;
        `};
    ${(props) =>
        props.size === 'small' &&
        `
            width: 24px;
            height: 24px;
        `};
    ${(props) =>
        props.size === 'medium' &&
        `
            width: 30px;
            height: 30px;
        `};
    ${(props) =>
        props.size === 'large' &&
        `
            width: 40px;
            height: 40px;
        `};
    ${(props) =>
        props.size === 'xLarge' &&
        `
            width: 50px;
            height: 50px;
        `};
    ${(props) => (props.width ? `width: ${props.width}` : '')}
    ${(props) => (props.height ? `height: ${props.height}` : '')}
`;

export interface StyledSvgElementProps {
    color?: Color;
}

export const StyledGroup = styled.g<StyledSvgElementProps>`
    fill: ${(props) => props.color || props.theme.text.subtle};
`;

export const StyledStrokedGroup = styled.g<StyledSvgElementProps>`
    stroke: ${(props) => props.color || props.theme.text.subtle};
`;

export const StyledPath = styled.path<StyledSvgElementProps>`
    fill: ${(props) => props.color || props.theme.text.subtle};
`;

export const StyledCircle = styled.circle<StyledSvgElementProps>`
    fill: ${(props) => props.color || props.theme.text.subtle};
`;
